export default function EquationRoot() {
  return (
    <svg
      preserveAspectRatio="xMinYMax slice"
      height="43"
      viewBox="0 0 296 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0 24.3711H9.5L14.5 37L21.5 2H294" stroke="#D4D7E2" strokeWidth="3" />
    </svg>
  )
}
